// Styles
import "./editorial-slider.scss";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initEditorialSlider = (context) => {
  const editorialSliderSection = context.closest(".shopify-section");
  if (!editorialSliderSection) return;

  const sliderContainer = editorialSliderSection.querySelector(
    ".editorial-slider__container"
  );
  if (sliderContainer) {
    new Swiper(sliderContainer, {
      loop: false,
      slidesPerView: 1.14,
      spaceBetween: 2,
      navigation: {
        prevEl: sliderContainer.querySelector(".editorial-slider__navigation--left"),
        nextEl: sliderContainer.querySelector(".editorial-slider__navigation--right"),
      },
      breakpoints: {
        1025: {
          slidesPerView: "auto",
        },
      },
    });
  }
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll(".editorial-slider__container"),
    (el) => {
      window.dAgency.initEditorialSlider(el);
    }
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll(".editorial-slider__container"),
      (el) => {
        window.dAgency.initEditorialSlider(el);
      }
    );
  });
}
